import { render, staticRenderFns } from "./CoreTime.vue?vue&type=template&id=0fff2b50"
import script from "./CoreTime.vue?vue&type=script&lang=js"
export * from "./CoreTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports